import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store , persistor  } from "./store/store";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import { PersistGate } from 'redux-persist/es/integration/react';
import ErrorFallback from "./ErrorFallback";


// Initialize Sentry
// Sentry.init({
//   dsn: "https://d06040ca9c56ed9025dae99da8057518@o4509008592896000.ingest.de.sentry.io/4509008631234640",
//   integrations: [browserTracingIntegration()],
//   tracesSampleRate: 1.0,
//   debug: false,
//   tracePropagationTargets: [],
// });





// const TestErrorComponent = () => {
//   useEffect(() => {
//     try {
//       throw new Error("Testing Sentry error");
//     } catch (err) {
//       Sentry.captureException(err);
//     }
//   }, []);

//   return null; // This component just runs the test error
// };

// Wrap the entire application in Sentry's Error Boundary
const SentryWrappedApp = () => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    {/* <TestErrorComponent /> */}
    <App />

  </Sentry.ErrorBoundary>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SentryWrappedApp />
      {/* <App /> */}
    </PersistGate>
  </Provider>
);
